






import { Component, Vue } from 'vue-property-decorator';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
library.add(faChevronUp);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class ScrollToTop extends Vue {
  isVisible = false;

  mounted(): void {
    window.addEventListener('scroll', this.toggleVisibility);
  }

  onUnmounted(): void {
    window.removeEventListener('scroll', this.toggleVisibility);
  }

  // Display the button when the page is scrolled more than 400px downward
  toggleVisibility(): void {
    this.isVisible = window.scrollY > 400;
  }

  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
